import { GetProjectProductInfoByIdDocument } from "@/generated/graphql";
import { useQuery } from "@apollo/client/react";

export function useProjectsById(id: string | null) {
  const {
    data: projectByIdData,
    loading,
    error,
    refetch,
  } = useQuery(GetProjectProductInfoByIdDocument, {
    variables: {
      id: id ?? "",
    },
    skip: !id,
    fetchPolicy: "cache-first",
  });

  return {
    project: projectByIdData?.project,
    loading,
    error,
    refetch,
  };
}
